/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HttpStatusCode } from './HttpStatusCode';
import {
	HttpStatusCodeFromJSON,
	HttpStatusCodeFromJSONTyped,
	HttpStatusCodeToJSON,
	HttpStatusCodeToJSONTyped,
} from './HttpStatusCode';

/**
 *
 * @export
 * @interface SetPrivacyDataAcceptedDateResponse
 */
export interface SetPrivacyDataAcceptedDateResponse {
	/**
	 *
	 * @type {HttpStatusCode}
	 * @memberof SetPrivacyDataAcceptedDateResponse
	 */
	statusCode?: HttpStatusCode;
	/**
	 *
	 * @type {Array<Error>}
	 * @memberof SetPrivacyDataAcceptedDateResponse
	 */
	errors?: Array<Error> | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof SetPrivacyDataAcceptedDateResponse
	 */
	succeded?: boolean;
}

/**
 * Check if a given object implements the SetPrivacyDataAcceptedDateResponse interface.
 */
export function instanceOfSetPrivacyDataAcceptedDateResponse(
	value: object
): value is SetPrivacyDataAcceptedDateResponse {
	return true;
}

export function SetPrivacyDataAcceptedDateResponseFromJSON(
	json: any
): SetPrivacyDataAcceptedDateResponse {
	return SetPrivacyDataAcceptedDateResponseFromJSONTyped(json, false);
}

export function SetPrivacyDataAcceptedDateResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): SetPrivacyDataAcceptedDateResponse {
	if (json == null) {
		return json;
	}
	return {
		statusCode: json['statusCode'] == null ? undefined : HttpStatusCodeFromJSON(json['statusCode']),
		errors: json['errors'] == null ? undefined : json['errors'],
		succeded: json['succeded'] == null ? undefined : json['succeded'],
	};
}

export function SetPrivacyDataAcceptedDateResponseToJSON(
	json: any
): SetPrivacyDataAcceptedDateResponse {
	return SetPrivacyDataAcceptedDateResponseToJSONTyped(json, false);
}

export function SetPrivacyDataAcceptedDateResponseToJSONTyped(
	value?: SetPrivacyDataAcceptedDateResponse | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		statusCode: HttpStatusCodeToJSON(value['statusCode']),
		errors: value['errors'],
		succeded: value['succeded'],
	};
}
